import { Badge, Tooltip } from "@shopify/polaris";
import React from "react";

export function WarningAddress({ node }) {
  if (!node) return null;

  return (
    <WarningAddressTooltip node={node}>
      <Badge children="Warning Address" status="attention" />
    </WarningAddressTooltip>
  );
}

function WarningAddressTooltip({ node, children }) {
  const content = [
    node.company ? node.company + ": " : null,
    [node.address1, node.address2].filter(Boolean),
    [node.city + ",", node.state, node.postalCode || ""].join(" "),
    node.country,
  ]
    .filter(Boolean)
    .join("");

  return (
    <Tooltip
      content={<div dangerouslySetInnerHTML={{ __html: content }}></div>}
    >
      {children}
    </Tooltip>
  );
}
